import {ChangeDetectionStrategy, Component} from '@angular/core';

@Component({
    selector: 'ngx-table-bar',
    templateUrl: './table-bar.component.html',
    styleUrls: ['./table-bar.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    preserveWhitespaces: false
})
export class NgxTableBar {
}
